import React, { forwardRef, memo, useMemo } from "react";
import { Button, Input, Table, Tag, Typography } from "antd";
import {
  CheckOutlined,
  RollbackOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import TableEmptyContent from "../../../Components/TableEmptyContent/TableEmptyContent";
import { getRankingComparisonColumns } from "../PlaygroundUtils";

const { Text } = Typography;

const RankingComparisonTable = memo(
  forwardRef(function RankingComparisonTable(
    {
      rankingRows,
      page,
      pageSize,
      totalRecords,
      searchInput,
      isSearching,
      loading,
      isStale,
      onSearchChange,
      onTableChange,
      onDiscard,
      onApplyChanges,
    },
    ref
  ) {
    const hasData = rankingRows && rankingRows.length > 0;
    const columns = useMemo(() => getRankingComparisonColumns(), []);

    return (
      <div ref={ref} className="box_wraper_div playground_comparison_card">
        <div className="table_head_wraper playground_table_header_row">
          <div className="playground_table_title_group">
            <Text className="table_head">
              Ranking Comparison (Simulation Result)
            </Text>
            {isStale && (
              <Tag color="orange" className="playground_stale_tag">
                Inputs modified — Re-run simulation to update
              </Tag>
            )}
          </div>
          <div className="playground_table_header_actions">
            <Input
              placeholder="Search spec, card no..."
              prefix={<SearchOutlined style={{ color: "#94a3b8" }} />}
              value={searchInput}
              onChange={onSearchChange}
              allowClear
              style={{ width: 280 }}
            />
          </div>
        </div>

        <Table
          rowKey="key"
          loading={loading}
          bordered
          className="antdTable playground-comparison-table"
          columns={columns}
          dataSource={rankingRows}
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "50", "100"],
            showTotal: (total, range) =>
              `Showing ${range[0]} to ${range[1]} of ${total} specifications`,
            responsive: true,
          }}
          onChange={onTableChange}
          locale={{ emptyText: <TableEmptyContent /> }}
        />

        <div className="playground_grid_actions">
          <Button icon={<RollbackOutlined />} onClick={onDiscard}>
            Discard & Exit
          </Button>
          {(hasData || isSearching) && (
            <Button
              type="primary"
              icon={<CheckOutlined />}
              onClick={onApplyChanges}
              disabled={isStale}
              title={isStale ? "Re-run simulation before applying changes" : undefined}
            >
              Apply Changes
            </Button>
          )}
        </div>
      </div>
    );
  })
);

export default RankingComparisonTable;
